var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"folder\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62 13.6156H0V59H62V13.6156ZM7.08556 9.07692H33.6571C31.8856 2.26923 29.2287 0.000225067 29.2287 0.000225067L9.29985 0C8.32149 0 7.08556 1.58324 7.08556 2.83654V9.07692Z",
    fill: "#FDA725"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.d4566c83ce9730462d4bc742c96feea5.svg";
export { ForwardRef as ReactComponent };